var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"identify-code-wrap",on:{"click":_vm.getIdentifyCode}},[(_vm.src)?_c('img',{staticClass:"identify-code",attrs:{"src":_vm.src}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }